const ADDRESS_FIELDS = [
  'name',
  'street',
  'houseNumber',
  'houseNumberExt',
  'addressExtra',
  'postalCode',
  'city',
  'countryCode',
  'phone',
  'region',
] as const;

export type AiAddressSparse = Partial<Record<(typeof ADDRESS_FIELDS)[number], string>>;

/** Build partial address objects containing only keys whose values differ (fixes only). */
type AddressFieldValues = Partial<Record<(typeof ADDRESS_FIELDS)[number], string | undefined>>

export function buildSparseAddressDiff(
  original: AddressFieldValues,
  corrected: AddressFieldValues,
): { original_address: AiAddressSparse; corrected_address: AiAddressSparse } {
  const original_address: AiAddressSparse = {};
  const corrected_address: AiAddressSparse = {};

  for (const key of ADDRESS_FIELDS) {
    const o = String(original[key] ?? '').trim();
    const c = String(corrected[key] ?? '').trim();
    if (o !== c) {
      original_address[key] = String(original[key] ?? '');
      corrected_address[key] = String(corrected[key] ?? '');
    }
  }

  return { original_address, corrected_address };
}

export function hasSignificantIssues(
  issues: Array<{ severity: string }> | undefined | null,
): boolean {
  return (issues ?? []).some((i) => i.severity === 'error' || i.severity === 'warning');
}
